import React from 'react';
import AnimatedCursor from "react-animated-cursor"

function Animatedcursor() {
  return (
    <div>
        <AnimatedCursor
      innerSize={15}
      outerSize={20}
      color='237, 28, 36'
      outerAlpha={0.2}
      innerScale={0.7}
      outerScale={5}
      clickables={[
        'a',
        'input[type="text"]',
        'input[type="email"]',
        'input[type="number"]',
        'input[type="submit"]',
        'input[type="image"]',
        'label[for]',
        'select',
        'textarea',
        'button',
        'i',
        '.link'
      ]}
    />
    </div>
  )
}

export default Animatedcursor;